import {
  ListItemText,
  MenuItem as MuiMenuItem,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react";
import * as React from "react";
import {
  ActionMenuItem,
  Menu,
  MenuItem,
  PageMenuItem,
} from "src/pi/application/Menu";
import ActionMenuItemComponent from "./ActionMenuItemComponent";
import MenuComponent from "./MenuComponent";
import PageMenuItemComponent from "./PageMenuItemComponent";

interface IProps {
  item: MenuItem;
  showIcon?: boolean;
}

const MenuItemComponent: React.FC<IProps> = observer((props) => {
  const { item, showIcon } = props;

  if (!item.isVisible) {
    return undefined;
  }

  if (item instanceof PageMenuItem) {
    return (
      <PageMenuItemComponent
        item={item}
        // textColor={textColor}
        showIcon={showIcon}
      />
    );
  }

  if (item instanceof Menu) {
    return <MenuComponent menu={item} showIcon={showIcon} />;
  }

  if (item instanceof ActionMenuItem) {
    return <ActionMenuItemComponent item={item} showIcon={showIcon} />;
  }

  return (
    <MuiMenuItem>
      <ListItemText primary={item.label} />
    </MuiMenuItem>
  );
});

export default MenuItemComponent;
